import { render, staticRenderFns } from "./ItemCategories.vue?vue&type=template&id=dbe02d04&scoped=true&"
import script from "./ItemCategories.vue?vue&type=script&lang=js&"
export * from "./ItemCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe02d04",
  null
  
)

export default component.exports